// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + chunkId + "." + {"229": "ff2f23e4","512": "ace71ba2",}[chunkId] + ".js"
}